import * as React from "react";
import styled from "styled-components";

const StyledCheckbox = styled.div`
  border-radius: ${props => props.theme.borderRadius};
  width: 24px;
  height: 24px;
  position: relative;
  border: 1px solid ${props => props.theme.colors.border};
`;

export const CheckboxUncheckedIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return <StyledCheckbox></StyledCheckbox>;
};
